import joeyPic from "@/public/images/artists/joey.png";
import { Artist } from "@/types/types";

export const joey = {
  id: "179",
  name: "Joey",
  image: joeyPic,
  description: `Joey's voice is pure dynamism—smooth, self-assured, and packed with a cool, effortless charisma. He glides over beats with a natural rhythm, shifting between sharp, cutting bars and melodic flows that hit just right. `,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjoey-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Deep"],
      secondary: ["Processed"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 52,
        high: 63,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
